import { Controller } from '@hotwired/stimulus'

// Recall drill mode (ux-design §3.7). Drives `data-compliance-drill-mode` on the
// surface, which the stylesheet desaturates — so a *simulated* recall can never
// be mistaken for a real one. Starts on for a drill; the toggle lets a demo
// flip it on and off.
export default class extends Controller {
  static targets = ['surface']
  static values = { active: Boolean }

  connect () {
    this.apply()
  }

  toggle () {
    this.activeValue = !this.activeValue
  }

  activeValueChanged () {
    this.apply()
  }

  apply () {
    this.surfaceTarget.dataset.complianceDrillMode = this.activeValue
  }
}
